import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Car, MapPin, Clock } from "lucide-react";

export default function DriverHistory() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/driver/trips/history").then((r) => setItems(r.data || []));
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <div className="px-5 pt-safe pt-8 pb-3">
        <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">Driver</p>
        <h1 className="font-display font-bold text-3xl text-slate-900">Trip History</h1>
      </div>

      <div className="px-5 mt-3 pb-32 space-y-2">
        {items.length === 0 ? (
          <div className="text-center py-16 text-slate-400" data-testid="driver-history-empty">
            <Car size={48} className="mx-auto opacity-40" />
            <p className="mt-3 font-semibold text-slate-500">No completed trips yet</p>
          </div>
        ) : (
          items.map((t) => (
            <div key={t.id} className="border border-slate-200 rounded-2xl p-4">
              <div className="flex items-center justify-between">
                <span className="font-mono text-[10px] text-slate-400">{t.ref}</span>
                <span className={`text-[10px] px-2 py-1 rounded-full font-bold uppercase tracking-wider ${
                  t.status === "completed" ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"
                }`}>
                  {t.status}
                </span>
              </div>
              <div className="mt-2 flex items-center justify-between">
                <div className="flex items-center gap-3 text-sm text-slate-600">
                  <span className="flex items-center gap-1"><MapPin size={13} /> {t.distance_km?.toFixed(1) || 0} km</span>
                  <span className="flex items-center gap-1"><Clock size={13} /> {t.duration_minutes || 0} min</span>
                </div>
                <span className="font-display font-bold text-primary">
                  AED {(25 + 2 * (t.distance_km || 0)).toFixed(0)}
                </span>
              </div>
              <p className="text-[10px] text-slate-400 mt-1 font-mono">
                {t.completed_at ? new Date(t.completed_at).toLocaleString("en-AE") : "—"}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
